import React, { memo, useCallback } from 'react';
import { Button, Icon, Typography } from '@ann/web-components';
import { WIDGET_LIBRARY_COPY } from '../../../../constants/dashboardBuilderCopy';
import WidgetPreviewRenderer from '../WidgetPreviewRenderer';
import {
  Container,
  Footer,
  PreviewArea,
  PreviewExpandButton,
  PreviewImage,
  PreviewInnerCard,
} from './WidgetPreviewItem.styled';

const WidgetPreviewItem = ({ widget, isSelected, onToggle, widgetId, onExpand }) => {
  const handleToggle = useCallback(
    (e) => {
      e.stopPropagation();
      onToggle(widgetId);
    },
    [onToggle, widgetId]
  );

  const handleExpandClick = useCallback(
    (e) => {
      e.stopPropagation();
      onExpand?.(widget);
    },
    [onExpand, widget]
  );

  return (
    <Container $selected={isSelected} onClick={handleToggle}>
      <PreviewArea>
        <PreviewExpandButton
          type="button"
          aria-label={WIDGET_LIBRARY_COPY.expandPreviewAriaLabel}
          onClick={handleExpandClick}
        >
          <Icon name="openInFull" size="small" />
        </PreviewExpandButton>
        <PreviewInnerCard>
          {widget.previewImage ? (
            <PreviewImage src={widget.previewImage} alt={widget.name} />
          ) : (
            <WidgetPreviewRenderer widget={widget} mode="thumbnail" />
          )}
        </PreviewInnerCard>
      </PreviewArea>
      <Footer>
        <Typography category="label" size="small" weight="bold">
          {widget.name}
        </Typography>
        <Button
          type={isSelected ? 'tertiary' : 'secondary'}
          size="small"
          label={
            isSelected
              ? WIDGET_LIBRARY_COPY.previewRemoveButton
              : WIDGET_LIBRARY_COPY.previewAddButton
          }
          iconLeft={isSelected ? 'delete2' : undefined}
          onClick={handleToggle}
        />
      </Footer>
    </Container>
  );
};

export default memo(WidgetPreviewItem);
